import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';
import { UserSharedService } from '../core/users/user.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[] = [];
    model_tm: any[] = [];
    

    constructor(
        public layoutService: LayoutService, 
        private userService: UserSharedService
    ) { }

    ngOnInit() {
        this.model = [
            {
                label: 'Dashboard',
                icon: 'wow wow-dashboard',
                visible: this.userService.hasSchoolPermission('DASHBOARD_ADMIN'),
                routerLink: ['/dashboard'],
            },
            {
                label: 'Dashboard',
                icon: 'wow wow-dashboard',
                visible: this.userService.hasSchoolPermission('DASHBOARD_STAFF'),
                routerLink: ['/dashboard/overview'],

            },
            {
                label: 'Schools',
                icon: 'wow wow-classroom',
                visible: localStorage.getItem('userRole') === 'super-admin',
                routerLink: ['/schools'],

            },
            {
                label: 'Classrooms',
                icon: 'wow wow-classroom',
                visible: this.userService.hasSchoolPermission('CLASSROOM_VIEW'),
                routerLink: ['/classrooms'],

            },
            {
                label: 'Users',
                icon: 'wow wow-staff',
                visible: this.userService.hasSchoolPermission('STAFF_VIEW'),
                routerLink: ['/users'],

            },
            {
                label: 'Products',
                icon: 'wow wow-wowcare-shopping-bag',
                visible: this.userService.hasSchoolPermission('PRODUCT_VIEW'),
                routerLink: ['/'],
                items: [
                    {
                        label: 'Categories',
                        icon: 'pi pi-fw pi-list',
                        visible : this.userService.hasSchoolPermission('VIEW_PRODUCT_CATEGORY'),
                        routerLink: ['/products/product-category'],
                    },
                    {
                        label: 'Product List',
                        icon: 'pi pi-building',
                        visible: this.userService.hasSchoolPermission('PRODUCT_VIEW'),
                        routerLink: ['/products/product-list'],
                    },
                ],
            },
            {
                label: 'Vendors',
                icon: 'wow wow-inv-person',
                visible: this.userService.hasSchoolPermission('VENDOR_VIEW'),
                routerLink: ['/'],
                items: [
                    {
                        label: 'Category',
                        icon: 'pi pi-fw pi-list',
                        visible: this.userService.hasSchoolPermission('VENDOR_CATEGORY_VIEW'),
                        routerLink: ['/vendors/vendor-category'],
                    },
                    {
                        label: 'Vendors',
                        icon: 'pi pi-building',
                        visible: this.userService.hasSchoolPermission('VENDOR_VIEW'),
                        routerLink: ['/vendors/vendor-list'],
                    },
                ],
            },
            {
                label: 'Requests',
                icon: 'wow wow-inv-request',
                visible: this.userService.hasSchoolPermission('REQUEST_VIEW'),
                routerLink: ['/requests'],

            },
            
            {
                label: 'Purchase',
                icon: 'wow wow-inv-purchase',
                visible: this.userService.hasSchoolPermission('PURCHASE_VIEW'),
                routerLink: ['/purchase'],

            },

            {
                label: 'Stocks',
                icon: 'wow wow-inv-stocks',
                visible: this.userService.hasSchoolPermission('STOCK_VIEW'),
                routerLink: ['/stocks'],

            },
            {
                label: 'Reports',
                icon: 'wow wow-inv-report',
                visible: this.userService.hasSchoolPermission('STOCK_VIEW'),
                routerLink: ['/reports'],

            },
            {
                label: 'Settings',
                icon: 'wow wow-inv-settings',
                visible: this.userService.hasSchoolPermission('STOCK_VIEW'),
                routerLink: ['/profile/user'],

            },
           
        ];
        this.model_tm = [
            {
                label: 'menu.DASHBOARD', icon: 'pi pi-home',
                items: [
                    { label: 'menu.SAAS', icon: 'pi pi-desktop', routerLink: ['/dashboard'] },
                    { label: 'menu.SALES', icon: 'pi pi-chart-bar', routerLink: ['/dashboard/dashboard-sales'] }
                ]
            },
            {
                label: 'menu.UI_KIT', icon: 'pi pi-star', routerLink: ['/uikit'],
                items: [
                    { label: 'menu.FORM_LAYOUT', icon: 'pi pi-id-card', routerLink: ['/uikit/formlayout'] },
                    { label: 'menu.INPUT', icon: 'pi pi-check-square', routerLink: ['/uikit/input'] },
                    { label: 'menu.FLOAT_LABEL', icon: 'pi pi-bookmark', routerLink: ['/uikit/floatlabel'] },
                    { label: 'menu.INVALID_STATE', icon: 'pi pi-exclamation-circle', routerLink: ['/uikit/invalidstate'] },
                    { label: 'menu.BUTTON', icon: 'pi pi-box', routerLink: ['/uikit/button'] },
                    { label: 'menu.TABLE', icon: 'pi pi-table', routerLink: ['/uikit/table'] },
                    { label: 'menu.LIST', icon: 'pi pi-list', routerLink: ['/uikit/list'] },
                    { label: 'menu.TREE', icon: 'pi pi-share-alt', routerLink: ['/uikit/tree'] },
                    { label: 'menu.PANEL', icon: 'pi pi-tablet', routerLink: ['/uikit/panel'] },
                    { label: 'menu.OVERLAY', icon: 'pi pi-clone', routerLink: ['/uikit/overlay'] },
                    { label: 'menu.MEDIA', icon: 'pi pi-image', routerLink: ['/uikit/media'] },
                    { label: 'menu.MENU', icon: 'pi pi-bars', routerLink: ['/uikit/menu'] },
                    { label: 'menu.MESSAGE', icon: 'pi pi-comment', routerLink: ['/uikit/message'] },
                    { label: 'menu.FILE', icon: 'pi pi-file', routerLink: ['/uikit/file'] },
                    { label: 'menu.CHART', icon: 'pi pi-chart-bar', routerLink: ['/uikit/charts'] },
                    { label: 'menu.MISC', icon: 'pi pi-circle-off', routerLink: ['/uikit/misc'] }
                ]
            },
            {
                label: 'menu.APPS',
                icon: 'pi pi-th-large',
                items: [
                    {
                        label: 'menu.BLOG',
                        icon: 'pi pi-fw pi-comment',
                        items: [
                            {
                                label: 'menu.LIST',
                                icon: 'pi pi-fw pi-image',
                                routerLink: ['/apps/blog/list']
                            },
                            {
                                label: 'menu.DETAIL',
                                icon: 'pi pi-fw pi-list',
                                routerLink: ['/apps/blog/detail']
                            },
                            {
                                label: 'menu.EDIT',
                                icon: 'pi pi-fw pi-pencil',
                                routerLink: ['/apps/blog/edit']
                            }
                        ]
                    },
                    {
                        label: 'menu.CALENDAR',
                        icon: 'pi pi-fw pi-calendar',
                        routerLink: ['/apps/calendar']
                    },
                    {
                        label: 'menu.CHAT',
                        icon: 'pi pi-fw pi-comments',
                        routerLink: ['/apps/chat']
                    },
                    {
                        label: 'menu.FILES',
                        icon: 'pi pi-fw pi-folder',
                        routerLink: ['/apps/files']
                    },
                    {
                        label: 'menu.KANBAN',
                        icon: 'pi pi-fw pi-sliders-v',
                        routerLink: ['/apps/kanban']
                    },
                    {
                        label: 'menu.MAIL',
                        icon: 'pi pi-fw pi-envelope',
                        items: [
                            {
                                label: 'menu.INBOX',
                                icon: 'pi pi-fw pi-inbox',
                                routerLink: ['/apps/mail/inbox']
                            },
                            {
                                label: 'menu.COMPOSE',
                                icon: 'pi pi-fw pi-pencil',
                                routerLink: ['/apps/mail/compose']
                            },
                            {
                                label: 'menu.DETAIL',
                                icon: 'pi pi-fw pi-comment',
                                routerLink: ['/apps/mail/detail/1000']
                            }
                        ]
                    },
                    {
                        label: 'menu.TASK_LIST',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['/apps/tasklist']
                    }
                ]
            },
            {
                label: 'menu.PRIME_BLOCKS', icon: 'pi pi-fw pi-prime', routerLink: ['/blocks'],
                items: [
                    { label: 'menu.FREE_BLOCKS', icon: 'pi pi-fw pi-eye', routerLink: ['/blocks'] },
                    { label: 'menu.ALL_BLOCKS', icon: 'pi pi-fw pi-globe', url: 'https://www.primefaces.org/primeblocks-ng', target: '_blank' }
                ]
            },
            {
                label: 'menu.UTILITIES', icon: 'pi pi-fw pi-compass', routerLink: ['/utilities'],
                items: [
                    { label: 'menu.PRIMEICONS', icon: 'pi pi-fw pi-prime', routerLink: ['utilities/icons'] },
                    { label: 'menu.COLORS', icon: 'pi pi-fw pi-palette', routerLink: ['utilities/colors'] },
                    { label: 'menu.PRIMEFLEX', icon: 'pi pi-fw pi-desktop', url: 'https://www.primefaces.org/primeflex/', target: '_blank' },
                    { label: 'menu.FIGMA', icon: 'pi pi-fw pi-pencil', url: 'https://www.figma.com/file/PgQXX4HXMPeCkT74tGajod/Preview-%7C-Verona-2022?node-id=1303%3A750', target: '_blank' }
                ]
            },
            {
                label: 'menu.PAGES',
                icon: 'pi pi-fw pi-briefcase',
                items: [
                    {
                        label: 'menu.LANDING',
                        icon: 'pi pi-fw pi-globe',
                        routerLink: ['/landing'],
                        data: { 'fullPage': true }
                    },
                    {
                        label: 'menu.AUTH',
                        icon: 'pi pi-fw pi-user',
                        items: [
                            {
                                label: 'menu.LOGIN',
                                icon: 'pi pi-fw pi-sign-in',
                                routerLink: ['/auth/login'],
                                data: { 'fullPage': true }
                            },
                            {
                                label: 'menu.ERROR',
                                icon: 'pi pi-fw pi-times-circle',
                                routerLink: ['/auth/error'],
                                data: { 'fullPage': true }
                            },
                            {
                                label: 'menu.ACCESS_DENIED',
                                icon: 'pi pi-fw pi-lock',
                                routerLink: ['/auth/access'],
                                data: { 'fullPage': true }
                            },
                            {
                                label: 'menu.REGISTER',
                                icon: 'pi pi-fw pi-user-plus',
                                routerLink: ['/auth/register'],
                                data: { 'fullPage': true }
                            },
                            {
                                label: 'menu.FORGOT_PASSWORD',
                                icon: 'pi pi-fw pi-question',
                                routerLink: ['/auth/forgotpassword'],
                                data: { 'fullPage': true }
                            },
                            {
                                label: 'menu.NEW_PASSWORD',
                                icon: 'pi pi-fw pi-cog',
                                routerLink: ['/auth/newpassword'],
                                data: { 'fullPage': true }
                            },
                            {
                                label: 'menu.VERIFICATION',
                                icon: 'pi pi-fw pi-envelope',
                                routerLink: ['/auth/verification'],
                                data: { 'fullPage': true }
                            },
                            {
                                label: 'menu.LOCK_SCREEN',
                                icon: 'pi pi-fw pi-eye-slash',
                                routerLink: ['/auth/lockscreen'],
                                data: { 'fullPage': true }
                            }
                        ]
                    },
                    {
                        label: 'menu.CRUD',
                        icon: 'pi pi-fw pi-pencil',
                        routerLink: ['/pages/crud']
                    },
                    {
                        label: 'menu.TIMELINE',
                        icon: 'pi pi-fw pi-calendar',
                        routerLink: ['/pages/timeline']
                    },
                    {
                        label: 'menu.INVOICE',
                        icon: 'pi pi-fw pi-dollar',
                        routerLink: ['/pages/invoice']
                    },
                    {
                        label: 'menu.ABOUT_US',
                        icon: 'pi pi-fw pi-user',
                        routerLink: ['/pages/aboutus']
                    },
                    {
                        label: 'menu.HELP',
                        icon: 'pi pi-fw pi-question-circle',
                        routerLink: ['/pages/help']
                    },
                    {
                        label: 'menu.NOT_FOUND',
                        icon: 'pi pi-fw pi-exclamation-circle',
                        routerLink: ['/pages/notfound']
                    },
                    {
                        label: 'menu.EMPTY',
                        icon: 'pi pi-fw pi-circle-off',
                        routerLink: ['/pages/empty']
                    },
                    {
                        label: 'menu.FAQ',
                        icon: 'pi pi-fw pi-question',
                        routerLink: ['/pages/faq']
                    },
                    {
                        label: 'menu.CONTACT_US',
                        icon: 'pi pi-fw pi-phone',
                        routerLink: ['/pages/contact']
                    }
                ]
            },
            {
                label: 'menu.E_COMMERCE',
                icon: 'pi pi-fw pi-wallet',
                items: [
                    {
                        label: 'menu.PRODUCT_OVERVIEW',
                        icon: 'pi pi-fw pi-image',
                        routerLink: ['ecommerce/product-overview']
                    },
                    {
                        label: 'menu.PRODUCT_LIST',
                        icon: 'pi pi-fw pi-list',
                        routerLink: ['ecommerce/product-list']
                    },
                    {
                        label: 'menu.NEW_PRODUCT',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['ecommerce/new-product']
                    },
                    {
                        label: 'menu.SHOPPING_CART',
                        icon: 'pi pi-fw pi-shopping-cart',
                        routerLink: ['ecommerce/shopping-cart']
                    },
                    {
                        label: 'menu.CHECKOUT_FORM',
                        icon: 'pi pi-fw pi-check-square',
                        routerLink: ['ecommerce/checkout-form']
                    },
                    {
                        label: 'menu.ORDER_HISTORY',
                        icon: 'pi pi-fw pi-history',
                        routerLink: ['ecommerce/order-history']
                    },
                    {
                        label: 'menu.ORDER_SUMMARY',
                        icon: 'pi pi-fw pi-file',
                        routerLink: ['ecommerce/order-summary']
                    }
                ]
            },
            {
                label: 'menu.USER_MANAGEMENT',
                icon: 'pi pi-fw pi-user',
                items: [
                    {
                        label: 'menu.LIST',
                        icon: 'pi pi-fw pi-list',
                        routerLink: ['profile/list']
                    },
                    {
                        label: 'menu.CREATE',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['profile/create']
                    }
                ]
            },
            {
                label: 'menu.HIERARCHY', icon: 'pi pi-align-left',
                items: [
                    {
                        label: 'menu.SUBMENU_1', icon: 'pi pi-align-left',
                        items: [
                            {
                                label: 'menu.SUBMENU_1_1', icon: 'pi pi-align-left',
                                items: [
                                    { label: 'menu.SUBMENU_1_1_1', icon: 'pi pi-align-left' },
                                    { label: 'menu.SUBMENU_1_1_2', icon: 'pi pi-align-left' },
                                    { label: 'menu.SUBMENU_1_1_3', icon: 'pi pi-align-left' }
                                ]
                            },
                            {
                                label: 'menu.SUBMENU_1_2', icon: 'pi pi-align-left',
                                items: [
                                    { label: 'menu.SUBMENU_1_2_1', icon: 'pi pi-align-left' }
                                ]
                            }
                        ]
                    },
                    {
                        label: 'menu.SUBMENU_2', icon: 'pi pi-align-left',
                        items: [
                            {
                                label: 'menu.SUBMENU_2_1', icon: 'pi pi-align-left',
                                items: [
                                    { label: 'menu.SUBMENU_2_1_1', icon: 'pi pi-align-left' },
                                    { label: 'menu.SUBMENU_2_1_2', icon: 'pi pi-align-left' }
                                ]
                            },
                            {
                                label: 'menu.SUBMENU_2_2', icon: 'pi pi-align-left',
                                items: [
                                    { label: 'menu.SUBMENU_2_2_1', icon: 'pi pi-align-left' }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                label: 'menu.START', icon: 'pi pi-download',
                items: [
                    {
                        label: 'menu.BUY_NOW', icon: 'pi pi-shopping-cart', url: 'https://www.primefaces.org/store'
                    },
                    {
                        label: 'menu.DOCUMENTATION', icon: 'pi pi-info-circle', routerLink: ['/documentation']
                    }
                ]
            }
        ];

    }
}
